import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "evrideo-ag-grid-evrideo-state-icon",
  templateUrl: "./ag-grid-evrideo-state-icon.component.html",
  styleUrl: "./ag-grid-evrideo-state-icon.component.scss",
})
export class AgGridEvrideoStateIconComponent
  implements ICellRendererAngularComp
{
  params: any;
  renderType: "progress" | "spinning" | "checked" | "not-checked" =
    "not-checked";
  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.determineRenderType();
  }
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.determineRenderType();
    return true;
  }
  private determineRenderType(): void {
    if (this.params) {
      if (this.params.isChecked) {
        this.renderType = "checked";
      } else if (
        this.params.renderType === "progress" &&
        typeof this.params.progress === "number"
      ) {
        this.renderType = "progress";
      } else if (
        this.params.renderType === "spinning" &&
        typeof this.params.progress === "number" &&
        this.params.progress > -1
      ) {
        this.renderType = "spinning";
      } else {
        this.renderType = "not-checked";
      }
    }
  }
}
